export default "__VITE_ASSET__Ci_T3dFV__"